import * as fromActions from '../actions/router-breadcrumbs.actions';

export interface RouterBreadcrumbState {
  breadcrumbs: Array<BreadcrumbObject>;
}

export interface BreadcrumbObject {
  title: string;
  customVariableTitle?: string;
  url: string;
  params?: any;
  localSearchKey?: string;
}

export const initialState: RouterBreadcrumbState = {
  breadcrumbs: [
    {
      title: 'Home',
      url: '',
    },
  ],
};

export function reducer(state = initialState, action: fromActions.RouterBreadcrumbsActions): RouterBreadcrumbState {
  switch (action.type) {
    case fromActions.ROUTER_UPDATE_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: action.payload,
      };
    default:
      return state;
  }
}

export const getBreadCrumbs = (state: RouterBreadcrumbState) => state.breadcrumbs;
